import React, {useRef, useState} from "react";
import {Form, Row, Col, Button, Modal, InputGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCamera, faPlus, faSearch} from "@fortawesome/free-solid-svg-icons";
import "../css/search.css";
import axios from "axios";
import {api} from "../api";
import {
    getRefreshToken, getTokenFromSession, refreshIdToken,
} from "../services/authenticate";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {addAge} from "../Store/ageState";
import {addLanguage} from "../Store/languageState";
import {addGenre} from "../Store/genreState";
import Webcam from "react-webcam";

import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import axiosInstance from "../axiosInstance";
import {saveBookDetails, searchBookUsingIsbnAndOptions} from "../Api/bookApi";
import {getImageUrlUsingIsbn, saveImageDetails} from "../Api/imageApi";

const IsbnSearch = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const webCamRef = useRef();
    const ageGroup = useSelector((state) => state.Age.items || []);
    const genre = useSelector((state) => state.Genre.genre || []);
    const language = useSelector((state) => state.Language.language || []);
    const [show, setShow] = useState(false);
    const [input, setInput] = useState("");
    const [category, setCategory] = useState("");
    const [imageSrc, setImageSrc] = useState(null);
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState(emptyFormData);
    const emptyFormData = {
        isbn: "",
        title: "",
        author: "",
        category: "",
        costPrice: "",
        ageGroup: "",
        publisher: "",
        isSeries: "",
        seriesId: "",
        publishedDate: "",
        currency: "",
        subject: "",
        page: "",
        size: "",
        weightInGrams: "",
        language: "",
        isBoxSet: "",
        bindingType: "",
        startingSellingPrice: "",
        startingLendingPrice: "",
        coverImagePath: "",
        description: "",
        status: "",
    };
    const [selectedOptions, setSelectedOptions] = useState(["IsbnDb", "OpenLibrary", "Google",]);

    const handleCheckboxChange = (value) => {
        setSelectedOptions((prev) => prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]);
    };

    const capture = () => {
        const imageSrc = webCamRef.current.getScreenshot();
        setImageSrc(imageSrc);
        setFormData({...formData, coverImagePath: imageSrc});
    };
    const fileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            setImageSrc(result);
            setFormData((prevFormData) => ({
                ...prevFormData, coverImagePath: result,
            }));
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };
    const upload = async () => {
        if (formData.isbn === "") {
            alert("Add the ISBN value");
            return;
        }
        if (!imageSrc) {
            alert("Capture the image");
            return;
        }
        if (!imageSrc.startsWith("data:image/jpeg;base64,")) {
            alert("Invalid image format");
            return;
        }
        const result = await saveImageDetails({imageDetails: imageSrc, isbn: formData.isbn})
        if (result.status === 200) {
            formData.coverImagePath = `${process.env.REACT_APP_IMAGE_BASE_URL}${formData.isbn}.jpg`;
            alert("Image uploaded successfully");
        } else {
            alert("Upload failed");
        }
    };

    const handleShow = (category) => {
        setCategory(category);
        setShow(!show);
        setInput("");
    };
    const addDetails = (input, category) => {
        if (category === "age") {
            dispatch(addAge(input));
        }
        if (category === "genre") {
            dispatch(addGenre(input));
        }
        if (category === "language") {
            dispatch(addLanguage(input));
        }
        setCategory("");
        setShow(!show);
        setInput("");
    };

    const searchBook = async (isbn) => {
        const response = await searchBookUsingIsbnAndOptions({isbn, selectedOptions});
        const data = response.data;
        if (response.status === 204) {
            alert("No isbn details is not found");
            return;
        }
        setFormData({
            isbn: data.isbn,
            title: data.title,
            author: data.author,
            category: data.category,
            costPrice: data.costPrice,
            ageGroup: data.ageGroup,
            publisher: data.publisher,
            isSeries: data.isSeries,
            seriesId: data.seriesId,
            publishedDate: data.publishedDate,
            currency: data.currency,
            subject: data.subject,
            page: data.page,
            size: data.size,
            weightInGrams: data.weightInGrams,
            language: data.language,
            isBoxSet: data.isBoxSet,
            bindingType: data.bindingType,
            startingSellingPrice: data.startingLendingPrice,
            startingLendingPrice: data.startingLendingPrice,
            coverImagePath: `${process.env.REACT_APP_IMAGE_BASE_URL}${formData.isbn}.jpg`,
            description: data.description,
            status: data.status,
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await saveBookDetails({bookDetails: formData});
        if (response.status >= 200 && response.status < 300) {
            alert("Book details successfully added");
            setFormData(emptyFormData)
        }
    };

    const fetchImage = async () => {
        const response = await getImageUrlUsingIsbn({isbn: formData.isbn})
        if (response.status === 200) {
            setFormData(prevState => ({
                ...prevState, coverImagePath: `${process.env.REACT_APP_IMAGE_BASE_URL}${formData.isbn}.jpg`
            }));
        }
    };

    return (<div>
        <div>
            <div>
                <Header/>
                <div style={{marginTop: "40px"}}>
                    <NavBar/>
                </div>
            </div>
            <div
                className="d-flex justify-content-center"
                style={{marginTop: "50px", marginLeft: "400px"}}
            >
                <Form className="w-75" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Row>
                                <Col>
                                    <Form.Group controlId="isbn">
                                        <Form.Label className="custom-label">ISBN</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter ISBN"
                                                required
                                                value={formData.isbn || ""}
                                                onChange={(e) => setFormData({...formData, isbn: e.target.value})}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        searchBook(formData.isbn);
                                                    }
                                                }}
                                            />
                                            <InputGroup.Text
                                                onClick={() => searchBook(formData.isbn)}
                                                style={{cursor: "pointer"}}
                                            >
                                                <FontAwesomeIcon icon={faSearch}/>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group controlId="checkboxGroup">
                                        <Form.Label>Options</Form.Label>
                                        <div>
                                            <Form.Check
                                                type="checkbox"
                                                label="IsbnDb"
                                                value="IsbnDb"
                                                checked={selectedOptions.includes("IsbnDb")}
                                                onChange={() => handleCheckboxChange("IsbnDb")}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                label="OpenLibrary"
                                                value="OpenLibrary"
                                                checked={selectedOptions.includes("OpenLibrary")}
                                                onChange={() => handleCheckboxChange("OpenLibrary")}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                label="Google"
                                                value="Google"
                                                checked={selectedOptions.includes("Google")}
                                                onChange={() => handleCheckboxChange("Google")}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col
                            md={3}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{
                                    width: "150%",
                                    height: "400px",
                                    position: "relative",
                                    padding: "0",
                                    overflow: "hidden",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                {open ? (<Webcam // Set to empty string
                                    audio={false}
                                    ref={webCamRef}
                                    screenshotFormat="image/jpeg"
                                    width="100%"
                                    height="100%"
                                    style={{
                                        width: "100%", height: "100%", objectFit: "cover",
                                    }}
                                />) : formData.coverImagePath ? (<img
                                    src={formData.coverImagePath}
                                    alt="Book Cover"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        borderRadius: "8px",
                                    }}
                                />) : (<span style={{color: "grey"}}>Image not available</span>)}

                                {imageSrc ? (<Button
                                    variant="light"
                                    className="position-absolute"
                                    style={{
                                        borderRadius: "50%",
                                        bottom: "10px",
                                        right: "10px",
                                        padding: "8px",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    }}
                                    onClick={upload}
                                >
                                    Upload
                                </Button>) : (<Button
                                    variant="light"
                                    className="position-absolute"
                                    style={{
                                        borderRadius: "50%",
                                        bottom: "10px",
                                        right: "10px",
                                        padding: "8px",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    }}
                                    onClick={() => setOpen(true)}
                                >
                                    <FontAwesomeIcon icon={faCamera}/>
                                </Button>)}
                            </div>

                            {open && (<Button
                                type="button"
                                style={{
                                    borderRadius: "50%",
                                    bottom: "10px",
                                    right: "10px",
                                    padding: "8px",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                                onClick={() => {
                                    capture();
                                    setOpen(false);
                                }}
                            >
                                Capture
                            </Button>)}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}></Col>
                        <Col md={3}>
                            {" "}
                            <div
                                style={{display: "flex", alignItems: "center", gap: "5px"}}
                            >
                                <input type="file" accept="image/*" onChange={fileUpload}/>
                                <button type="button" onClick={fetchImage}>
                                    Internet Search
                                </button>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group controlId="title">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                value={formData.title || ""}
                                required
                                onChange={(e) => setFormData({...formData, title: e.target.value})}
                                style={{width: "45%"}}
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group controlId="authors">
                            <Form.Label>Authors</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter authors"
                                required
                                value={formData.author || ""}
                                onChange={(e) => setFormData({...formData, author: e.target.value})}
                                style={{width: "45%"}}
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="ageGroup">
                                <Form.Label className="custom-label">Age Group</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={formData.ageGroup || ""}
                                        required
                                        onChange={(e) => setFormData({
                                            ...formData, ageGroup: e.target.value,
                                        })}
                                    >
                                        {!ageGroup.includes(formData.ageGroup) && (<option value=""></option>)}
                                        {ageGroup.map((age, index) => (<option key={index} value={age}>
                                            {age}
                                        </option>))}
                                    </Form.Select>

                                    <Button
                                        variant="link"
                                        style={{color: "black"}}
                                        onClick={() => {
                                            handleShow("age");
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="category">
                                <Form.Label className="custom-label">Category</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={formData.category || ""}
                                        required
                                        onChange={(e) => setFormData({...formData, category: e.target.value})}
                                    >
                                        {!genre.includes(formData.category) && (<option value=""></option>)}
                                        {genre.map((genreItem, index) => (<option key={index} value={genreItem}>
                                            {genreItem}
                                        </option>))}
                                    </Form.Select>
                                    <Button
                                        variant="link"
                                        style={{color: "black"}}
                                        onClick={() => handleShow("genre")}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="costPrice">
                                <Form.Label className="custom-label">Cost price</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Enter cost price"
                                    value={formData.costPrice || ""}
                                    onChange={(e) => setFormData({...formData, costPrice: e.target.value})}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="weightInGrams">
                                <Form.Label className="custom-label">
                                    Weight in grams
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter weight"
                                    value={formData.weightInGrams || ""}
                                    onChange={(e) => setFormData({
                                        ...formData, weightInGrams: e.target.value,
                                    })}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="language">
                                <Form.Label className="custom-label">Language</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={formData.language || ""}
                                        onChange={(e) => setFormData({...formData, language: e.target.value})}
                                    >
                                        {!language.includes(formData.language) && (<option value=""></option>)}
                                        {language.map((value, index) => (<option key={index} value={value}>
                                            {value}
                                        </option>))}
                                    </Form.Select>
                                    <Button
                                        variant="link"
                                        style={{color: "black"}}
                                        onClick={() => handleShow("language")}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="bindingType">
                                <Form.Label className="custom-label">Binding Type</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.bindingType}
                                    placeholder="Enter the binding type"
                                    onChange={(e) => setFormData({...formData, bindingType: e.target.value})}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="isSeries">
                                <Form.Label className="custom-label">Is Series</Form.Label>
                                <div className="d-flex">
                                    <Form.Select
                                        value={formData.isSeries || ""}
                                        onChange={(e) => setFormData({...formData, isSeries: e.target.value})}
                                    >
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Select>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="publisher">
                                <Form.Label className="custom-label">Publisher</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.publisher}
                                    placeholder="Enter the Publisher Name"
                                    onChange={(e) => setFormData({...formData, publisher: e.target.value})}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="sericesId">
                                <Form.Label className="custom-label">SeriesID</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.seriesId}
                                    placeholder="Enter the series id"
                                    onChange={(e) => setFormData({...formData, seriesId: e.target.value})}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="publishedDate">
                                <Form.Label className="custom-label">
                                    Published Date
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.publishedDate}
                                    placeholder="Enter the publishedDate"
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData, publishedDate: e.target.value,
                                        });
                                    }}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="currency">
                                <Form.Label className="custom-label">Currency</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.currency}
                                    placeholder="Enter the currency"
                                    onChange={(e) => setFormData({...formData, currency: e.target.value})}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="subject">
                                <Form.Label className="custom-label">Subject</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.subject}
                                    placeholder="Enter the Subject"
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData, subject: e.target.value,
                                        });
                                    }}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="page">
                                <Form.Label className="custom-label">Page</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.page}
                                    placeholder="Enter the Page"
                                    onChange={(e) => setFormData({...formData, page: e.target.value})}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group controlId="size">
                                <Form.Label className="custom-label">Size</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.size}
                                    placeholder="Enter the Size"
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData, size: e.target.value,
                                        });
                                    }}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group controlId="isBoxSet">
                                <Form.Label className="custom-label">isBoxSet</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.isBoxSet}
                                    placeholder="Enter the IsBoxSet"
                                    onChange={(e) => setFormData({...setFormData, isBoxSet: e.target.value})}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={3}></Col>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group controlId="title">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                value={formData.description || ""}
                                required
                                onChange={(e) => setFormData({...formData, description: e.target.value})}
                                style={{width: "45%"}}
                            />
                        </Form.Group>
                    </Row>
                    <Button
                        variant="primary"
                        type="submit"
                        className="w-30 d-flex justify-content-center"
                    >
                        Save
                    </Button>
                </Form>
                <Modal show={show} onHide={() => handleShow("")}>
                    <Modal.Header closeButton>
                        <Modal.Title>Enter the value</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="ageCategory">
                                <Form.Label>{`Enter the ${category}`}</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                ></Form.Control>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            onClick={() => {
                                addDetails(input, category);
                            }}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    </div>);
};

export default IsbnSearch;
